import { createContext, useCallback, useContext, useState } from "react";

const STORAGE_KEY = "stella_polaris_applied_v1";

const ApplyContext = createContext({
  isOpen: false,
  open: () => {},
  close: () => {},
  hasApplied: false,
  markApplied: () => {},
  resetApplied: () => {},
});

const readFlag = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const ApplyProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  // Lazy-init from localStorage so the very first paint already reflects the
  // persisted state (avoids a brief flash of "Apply" before "Under review").
  const [hasApplied, setHasApplied] = useState(readFlag);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const markApplied = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch {
      /* ignore */
    }
    setHasApplied(true);
  }, []);

  const resetApplied = useCallback(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
    setHasApplied(false);
  }, []);

  return (
    <ApplyContext.Provider
      value={{ isOpen, open, close, hasApplied, markApplied, resetApplied }}
    >
      {children}
    </ApplyContext.Provider>
  );
};

export const useApply = () => useContext(ApplyContext);
